import React from "react";
import { getStoredUser, getUserRole, ROLES } from "../auth/roles";
import AdminDashboard from "./AdminDashboard";
import MemberDashboard from "./MemberDashboard";

const RoleDashboard = () => {
  const user = getStoredUser();

  if (getUserRole(user) === ROLES.ADMIN) {
    return <AdminDashboard user={user} />;
  }

  return <MemberDashboard user={user} />;
};

export default RoleDashboard;
